import type { InjectionKey, Ref } from 'vue';
import type Glide from '@glidejs/glide';

export const gliderInjectionKey = Symbol(
  'free-carousel:glider',
) as InjectionKey<Ref<Glide | null>>;
export const numberOfSlidesInjectionKey = Symbol(
  'free-carousel:number-of-slides',
) as InjectionKey<Ref<number>>;
